import { defineMessages } from 'react-intl';

export default defineMessages({
    TWIAAgentRegistration: {
        id: 'agent.registration.views.TWIA Agent New Registration',
        defaultMessage: 'TWIA Agent Registration',
    },
    TFPAAgentRegistration: {
        id: 'agent.registration.views.TFPA Agent New Registration',
        defaultMessage: 'TFPA Agent Registration',
    },
    TWIARegistration: {
        id: 'agent.registration.views.TWIA New Registration',
        defaultMessage: 'TWIA Registration',
    },
    TFPARegistration: {
        id: 'agent.registration.views.TFPA New Registration',
        defaultMessage: 'TFPA Registration',
    },
    AgentRegistration: {
        id: 'agent.registration.views.New Registration',
        defaultMessage: 'Agent Registration',
    },
    TWIAAgentRegistrationLicense: {
        id: 'agent.registration.views.TWIA New Registration License',
        defaultMessage: 'TWIA Agent Registration (TDI License# {licenseNumber})',
    },
    TFPAAgentRegistrationLicense: {
        id: 'agent.registration.views.TFPA New Registration License',
        defaultMessage: 'TFPA Agent Registration (TDI License# {licenseNumber})',
    },
    cancelTFPAModalMessage: {
        id: 'agent.registration.views.TFPA Modal Cancel Message',
        defaultMessage: 'Are you sure you want to cancel the registration with TFPA? The information you have provided will be lost if you cancel.',
    },
    cancelTWIAModalMessage: {
        id: 'agent.registration.views.TWIA Modal Cancel Message',
        defaultMessage: 'Are you sure you want to cancel the registration with TWIA? The information you have provided will be lost if you cancel.',
    },
    cancelENTModalTitle: {
        id: 'agent.registration.views.ENT Modal Title',
        defaultMessage: 'Are you sure you want to exit?',
    },
    sideNavTitle: {
        id: 'agent.registration.views.Side Nav Title',
        defaultMessage: 'Are you sure you want to leave this page?'
    },
    sideNavMessage: {
        id: 'agent.registration.views.Side Nav Message',
        defaultMessage: 'Changes entered on this page may be lost.'
    },
    cancelButtonMsg: {
        id: 'agent.registration.views.cancelButtonMsg',
        defaultMessage: 'Cancel'
    },
    okButtonMsg: {
        id: 'agent.registration.views.okButtonMsg',
        defaultMessage: 'OK'
    }
})